import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getRemotes() {
    return dispatch => {
        return apiCaller
            .call(api.getAllRemotes())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_REMOTES',
                        remotes: data.remotes
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHERemotes - ', error);
                throw error;
            });
    };
}
function getRemoteDetails(remoteId) {
    return dispatch => {
        return apiCaller
            .call(api.getRemoteDetails(remoteId))
            .then(({ data }) => {
                if (!data.success) throw 'general.error.data_has_not_correctly_returned_by_server';
                dispatch({
                    type: 'MYFHE__FHEPRODUCT_UPDATE_REMOTES',
                    Remotes: data.remoteDetails
                });
                return JSON.parse(data.dataFrames);
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHERemoteDetails - ', error);
                throw error;
            });
    };
}

export { getRemotes, getRemoteDetails };



// WEBPACK FOOTER //
// ./environments/myfhe/data/Remote/actions.js